import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { ScrollToTop } from './components/ScrollToTop';
// Lazy load ShopPage — not needed on initial landing
const ShopPage = lazy(() => import('./pages/ShopPage').then(m => ({
  default: m.ShopPage
})));
(function initPixelStub() {
  const w = window as any;
  if (w.fbq) return;
  const n = w.fbq = function (...args: any[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
  };
  if (!w._fbq) w._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [] as any[];
  w.fbq('init', '919180517627113');
  w.fbq('track', 'PageView');
})();
export function App() {
  useEffect(() => {
    // Load Meta Pixel script — deferred to not block FCP/LCP
    const loadPixelScript = () => {
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=919180517627113&ev=PageView&noscript=1';
      document.body.appendChild(img);
    };
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(loadPixelScript, {
        timeout: 1500
      });
    } else {
      setTimeout(loadPixelScript, 800);
    }
  }, []);
  return <>
      <ScrollToTop data-id="element-0" />
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/tienda" element={<Suspense fallback={<div className="min-h-screen bg-[#0A0A0B]" data-id="element-6" />} data-id="element-5">
              <ShopPage data-id="element-7" />
            </Suspense>} data-id="element-4" />
      </Routes>
    </>;
}